/* eslint-disable no-underscore-dangle */
import { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import makeComponentTrashable from 'trashable-react';
import PropTypes from 'prop-types';
import { fetchDebtorCurrentLedger, fetchDebtorAveragePayments } from 'Shared/util/web-api';
import Spinner from 'Shared/components/spinner';
import { getPieChartFilterValue } from 'Shared/components/charts/pie-chart-utils';
import { getBarChartData } from 'Pages/debtors/debtor-utils';
import DebtorPieChart from 'Pages/debtors/debtor-pie-chart';
import DebtorBarChart from 'Pages/debtors/debtor-bar-chart';
import { formatShortDate } from 'Shared/util/formatters';
import { useTranslation } from 'Shared/util/custom-hooks';
import styles from './debtor-section.css';


const DebtorSection = ({
  registerPromise,
  history,
}) => {
  const [currentLedger, setCurrentLedger] = useState([]);
  const [averagePayments, setAveragePayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const t = useTranslation(x => x.debtorsPage);

  useEffect(() => {
    Promise.all([
      registerPromise(fetchDebtorCurrentLedger()),
      registerPromise(fetchDebtorAveragePayments()),
    ])
      .then(([ledger, payments]) => {
        setCurrentLedger(ledger);
        setAveragePayments(payments);
        setLoading(false);
      });
  }, []);

  const handlePieChartClick = (label, index) => {
    history.push({
      pathname: '/ledger',
      state: { pieChartLabelWithIndex: getPieChartFilterValue(null, index, label) },
    });
  };

  const barChartData = formatShortDate(getBarChartData(averagePayments));

  return (
    <>
      {loading ? <Spinner /> : (
        <div className={styles.container}>
          <DebtorPieChart
            headerText={t.currentLedger}
            invoices={currentLedger}
            onClick={(element, chart) => handlePieChartClick(chart.props.data.labels[element._index], element._index)}
            legend={{
              onClick: (label, index) => handlePieChartClick(label, index),
            }}
          />
          <DebtorBarChart
            headerText={t.averagePaymentPeriodAfterDueDate}
            label={t.paymentTime}
            data={barChartData}
          />
        </div>
      )}
    </>
  );
};

DebtorSection.propTypes = {
  registerPromise: PropTypes.func.isRequired,
  history: PropTypes.shape({ push: PropTypes.func.isRequired }).isRequired,
};

export default makeComponentTrashable(withRouter(DebtorSection));
